import React from 'react';
import styled from 'styled-components';

interface ContainerProps {
    children: React.ReactNode;
    maxWidth?: string;
    narrow?: boolean;
}

const StyledContainer = styled.div<{ $maxWidth?: string; $narrow?: boolean }>`
    max-width: ${({ $maxWidth, $narrow }) => 
        $maxWidth || ($narrow ? '800px' : '1200px')};
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing.md};
    
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 ${({ theme }) => theme.spacing.sm};
    }
`;

export const Container: React.FC<ContainerProps> = ({ children, maxWidth, narrow }) => {
    return (
        <StyledContainer $maxWidth={maxWidth} $narrow={narrow}>
            {children}
        </StyledContainer>
    );
};
